// ─────────────────────────────────────────────────────────────────────────────
// Module-internal config values of the search module.
// ─────────────────────────────────────────────────────────────────────────────

export const SEARCH_PAGE_RESULTS_LIMIT = 200

export const SEARCH_MIN_QUERY_LENGTH = 3

export const SEARCH_QUERY_INSTANT_RESULTS_DISPLAY_COUNT = 12 // ensure enough results to show scrollable list
export const SEARCH_QUERY_SUGGESTIONS_DISPLAY_COUNT = 8
export const SEARCH_QUERY_DEBOUNCE_TIME = 500 // value based on users average age (typing speed 25 WPM), important for optimizing Algolia search requests count.

// Trending section of the search dropdown - how confident and how many recommendations we ask for.
export const SEARCH_TRENDING_THRESHOLD = 40
export const SEARCH_TRENDING_PRODUCTS_MAX_COUNT = 30
export const SEARCH_TRENDING_FACETS_MAX_COUNT = 10
